var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { connect } from "react-redux";
import { injectIntl, defineMessages } from "react-intl";
import Loader from "../../../Loader";
import { getRandomGames, searchGames } from "../../../../actions/games/creators";
import GamesList from "../GamesList";
import GamesRandomList from "../GamesList/GamesRandomList";
import GamesOrderedPreviews from "../GamesOrderedPreviews/GamesOrderedPreviews";
import GamesProviderSort from "../GamesProviderSort/GamesProviderSort";
import { EmptyMessage } from "../styles";
var messages = defineMessages({
    empty_search_games_title: {
        id: "empty_search_games_title",
        defaultMessage: "Все игры",
    },
    empty_search_games_subTitle: {
        id: "empty_search_games_subTitle",
        defaultMessage: "Может понравится что-то из этого?",
    },
    loading: {
        id: "loading",
        defineMessages: "Загрузка..."
    }
});
var GamesSearched = /** @class */ (function (_super) {
    __extends(GamesSearched, _super);
    function GamesSearched() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formatFilterOptions = function (option) {
            return Array.from(option)
                .map(function (item) { return item[0]; })
                .join(",");
        };
        _this.getGames = function (params) {
            var _a = _this.props, user = _a.user, selectedProviders = _a.selectedProviders, selectedTypes = _a.selectedTypes, isTop = _a.isTop;
            var types = _this.formatFilterOptions(selectedTypes);
            var providers = _this.formatFilterOptions(selectedProviders);
            var name = _this.props.inputValue.trim();
            _this.props.searchGamesAction(__assign({ name: name, types: types, providers: providers, gamblerId: user.gamblerId, isTop: isTop }, params));
        };
        _this.getRandomGames = function (params) {
            _this.props.getRandomGamesActions(__assign({}, params));
        };
        return _this;
    }
    GamesSearched.prototype.render = function () {
        var _a = this.props, intl = _a.intl, darkTheme = _a.darkTheme, data = _a.data, randomGames = _a.randomGames, isLoading = _a.isLoading, isLoadingRandom = _a.isLoadingRandom, hasGames = _a.hasGames, selectedProviders = _a.selectedProviders, selectedTypes = _a.selectedTypes, isTop = _a.isTop, inputValue = _a.inputValue;
        var hasMainGames = data.Items && data.Items.length > 0;
        var showEmptyState = !isLoading && !hasGames && !hasMainGames;
        var isEmpty = !hasMainGames || !(randomGames.Items && randomGames.Items.length);
        var isProviderSection = selectedProviders.size > 0 &&
            selectedTypes.size === 0 &&
            !inputValue.trim() &&
            !isTop;
        if (this.props.orderedMode) {
            return _jsx(GamesOrderedPreviews, {});
        }
        return (_jsxs("div", { children: [isProviderSection && _jsx(GamesProviderSort, {}), isLoadingRandom && _jsx(Loader, {}), isEmpty && (isLoading || isLoadingRandom) && (_jsx("div", __assign({ style: { padding: "25px", textAlign: "center" } }, { children: intl.formatMessage(messages.loading) }))), showEmptyState && !isLoadingRandom && (_jsxs(EmptyMessage, __assign({ darkTheme: darkTheme }, { children: [intl.formatMessage(messages.empty_search_games_title), _jsx("div", { children: intl.formatMessage(messages.empty_search_games_subTitle) })] }))), showEmptyState && _jsx(GamesRandomList, { fetchData: this.getRandomGames }), _jsx(GamesList, { fetchData: this.getGames })] }));
    };
    return GamesSearched;
}(React.Component));
var mapStateToProps = function (state) {
    var _a = state.games.games, data = _a.data, isLoading = _a.isLoading, isTop = _a.isTop, hasGames = _a.hasGames;
    var _b = state.games.randomGames, randomGames = _b.data, isLoadingRandom = _b.isLoading;
    var _c = state.games.gamesFilter, providers = _c.providers, types = _c.types, error = _c.error, selectedTypes = _c.selectedTypes, selectedProviders = _c.selectedProviders, searchedGames = _c.searchedGames;
    return {
        data: data,
        randomGames: randomGames,
        providers: providers,
        types: types,
        isLoading: isLoading,
        isLoadingRandom: isLoadingRandom,
        hasGames: hasGames,
        isTop: isTop,
        error: error,
        selectedTypes: selectedTypes,
        selectedProviders: selectedProviders,
        searchedGames: searchedGames,
        orderedMode: state.games.orderedGames.mode,
        user: state.auth.user,
        langId: state.application.get("languageId"),
        darkTheme: state.application.get("darkTheme"),
    };
};
var mapDispatchToProps = {
    searchGamesAction: searchGames,
    getRandomGamesActions: getRandomGames,
};
export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(GamesSearched));



// WEBPACK FOOTER //
// ./src/components/games/components/GamesSearched/GamesSearched.jsx